export enum MenuSelectedEnum {
  all = "all",
  admins = "admins",
  gerentes = "gerentes",
  reclutamiento = "reclutamiento",
}
export interface ActionMenuSelected {
  payload: MenuSelectedEnum;
}
